import React from 'react';
import { ShieldCheck } from 'lucide-react'; // Assuming you are using Lucide

const VerifiedBadgeIcon = (size) => {
  return (
    <div style={{ padding: '1.5rem', textAlign: 'center' }}>
      
      {/* 1. Define the Gradient (Invisible, just for reference) */}
      <svg width="0" height="0">
        <defs>
          <linearGradient id="shield-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fbbf24" />
            <stop offset="100%" stopColor="#d97706" />
          </linearGradient>

          <linearGradient id="shieldGradientGreen" x1="2.00003" y1="5.99999" x2="22" y2="20" gradientUnits="userSpaceOnUse">
            <stop stopColor="#34d399" /> {/* Emerald 400 */}
            <stop offset="1" stopColor="#059669" /> {/* Emerald 600 */}
          </linearGradient>


        </defs>
      </svg>

      {/* 2. The Icon using the Gradient */}
      <ShieldCheck 
          size={size} 
          style={{ marginBottom: '10px' }} 
          
          /* This fills the inside with your gradient */
          fill="url(#shieldGradientGreen)" 
          
          /* This makes the outline and the checkmark white */
          stroke="white" 
          strokeWidth={2}
      />
      
    </div>
  );
};
export default VerifiedBadgeIcon;



/*

          <linearGradient id="shield-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fbbf24" />
            <stop offset="100%" stopColor="#d97706" />
          </linearGradient>

*/